<!--inspection container -->
<div class="inspection-container">
  <ng-container *ngIf="inspectionReport">
    <div fxLayout="row wrap" class="report-menu-container">

      <div fxLayoutAlign="start center" fxFlexOffset="10px">
      </div>

      <div fxLayoutAlign="end end">
        <ng-container *ngIf="isEditing || isDraftProcessing">
          <button mat-button color="primary" class="custom-button" [disabled]="isProcess || isReadOnly() || isDraftProcessing || (isDesktopAndOffline && !isOfflinePreviewReady)"
                  (click)="openPropertiesDialog()" style="width: 126px;">
            <mat-icon aria-label="">assignment</mat-icon>{{'inspectionReport.Properties' | translate}}
          </button>
          <button mat-button color="primary" class="custom-button" [disabled]="isProcess || isReadOnly() || !isEditabletexts || isDraftProcessing || (isDesktopAndOffline && !isOfflinePreviewReady)"
                  (click)="openEditableTextsDialog()" style="width: 180px;">
            <mat-icon class="text-icon" aria-label="">border_color</mat-icon>{{'inspectionReport.EditReportText' | translate}}
          </button>

        </ng-container>

        <ng-container *ngIf="isEditing || isDraftProcessing">
          <button mat-button color="warn" [disabled]="isDesktopAndOffline" [ngClass]="{ 'incomplete' : isDesktopAndOffline }" (click)="shareDraftInspectionReportPdf()" style="width: 142px;">
            <mat-icon aria-label="">share</mat-icon>{{'inspectionReport.ShareDraft' | translate}}
          </button>
          <button *ngIf="!isDraftProcessing" mat-button class="download" color="primary" style="width: 158px;"
            [disabled]="isProcess || isProcessingCreateReport || (isDesktopAndOffline && !isOfflinePreviewReady)" (click)="downloadDraftInspectionReportPdf()">
            <mat-icon class="pdf-icon" aria-label="">picture_as_pdf</mat-icon>
            {{'inspectionReport.DraftDownload' | translate}}
          </button>

          <button *ngIf="isDraftProcessing" mat-button class="download processing" color="primary"
            (click)="cancelGeneratePDF(true)" [matTooltip]="'inspectionReport.CancelGeneFinalPdf' | translate">
              <mat-icon class="pdf-icon" aria-label="">picture_as_pdf</mat-icon>
              {{'inspectionReport.CancelProcessing' | translate}}
          </button>
        </ng-container>
        <ng-container *ngIf="isCompleted || isFinalProcessing">
          <button *ngIf="isCompleted" mat-button color="primary" [disabled]="isDownload || isDesktopAndOffline" (click)="openShareDialog()">
            <mat-icon aria-label="">share</mat-icon>{{'inspectionReport.Share' | translate}}
          </button>
          <button *ngIf="isCompleted" mat-button class="download" color="primary" [disabled]="isDownload" (click)="downloadInspectionReportPdf()"
            download="report.pdf">
            <mat-icon class="pdf-icon" aria-label="">picture_as_pdf</mat-icon>
            {{'inspectionReport.Download' | translate}}
          </button>
          <button *ngIf="isFinalProcessing" mat-button class="download processing" color="primary"
            (click)="cancelGeneratePDF(false)" [matTooltip]="'inspectionReport.CancelGeneFinalPdf' | translate">
              <mat-icon class="pdf-icon" aria-label="">picture_as_pdf</mat-icon>
              {{'inspectionReport.CancelProcessing' | translate}}
          </button>
        </ng-container>

        <ng-container *ngIf="isEditing || isDraftProcessing">
          <div class="tooltip-wrapper"  [matTooltip]="(isDesktopAndOffline && !isDefaultOfflineUser) ? ('inspectionReport.DoneDisabledHint' | translate) : ''">
            <button mat-button class="incomplete" color="warn" [disabled]="isProcess || isDone || isReadOnly() || isDraftProcessing || (isDesktopAndOffline && !isDefaultOfflineUser)"
                    mat-raised-button (click)="checkReportValidation()">
              <mat-icon
                class="done-icon" aria-label="">check</mat-icon>{{'inspectionReport.Done' | translate}}
            </button>
          </div>

        </ng-container>
        <ng-container *ngIf="!isError && isCompleted">
          <button mat-button color="primary" class="completed" disabled>
            <mat-icon class="completed-icon" aria-label="">task</mat-icon>
            <span class="completed-span">{{'inspectionReport.Completed' | translate}}</span>
          </button>
          <button mat-button color="primary" class="completed" [disabled]="isReadOnly() || isDeletedInspection || isFinalProcessing" (click)="createNewVersionReport()">
            <span class="completed-span">{{'inspectionReport.ReEdit' | translate}}</span>
          </button>
        </ng-container>
      </div>
    </div>

    <div class="inspection-data-management-content">
      <!--iframe-->
      <ng-container *ngIf="!isCompleted">
        <!-- preview -->
        <div class="report-preview">
          <ng-container *ngIf="!isEdge(browserName) && !isDesktopAndOffline">
            <iframe *ngIf="previewUrl" [src]="previewUrl" #iframe >
              <h3>{{'inspectionReport.LoadPreview' | translate}}</h3>
            </iframe>
          </ng-container>

          <ng-container *ngIf="isDesktopAndOffline">
            <app-report-preview-offline id="offline-draft-report" (pageRendered)="previewRendered($event)"></app-report-preview-offline>
          </ng-container>

          <ng-container *ngIf="isEdge(browserName)">
            <iframe #edgeIframe>
              <h3>{{'inspectionReport.LoadPreview' | translate}}</h3>
            </iframe>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="isCompleted">
        <!-- pdf not iPad -->
        <div *ngIf="!isDeviceNameIpad(deviceName)" class="report-preview">
          <!--no plugin-->
          <ng-container *ngIf="!isPlugin">
            <h3 class="display-message">{{'inspectionReport.MsgInstallPDFViewer' | translate}}</h3>
          </ng-container>

          <!-- complete chrome/edge -->
          <ng-container *ngIf="!isSafari(browserName) || !isDesktopAndOffline">
            <iframe *ngIf="pdfUrl" [src]="pdfUrl" type="application/pdf">
              <h3 *ngIf="!isError && isDownload">{{'inspectionReport.LoadPDF' | translate}}</h3>
              <h3 *ngIf="isError">{{'inspectionReport.PageNotFound' | translate}}</h3>
            </iframe>
            <h4 class="display-message" *ngIf="isError && !isProcessingCreateReport">{{'inspectionReport.UnDisplayPDFRpt' | translate}}</h4>
            <h4 class="display-message" *ngIf="isError && isProcessingCreateReport && !isDesktopAndOffline">{{'inspectionReport.MsgPressRefresh1' | translate}}</h4>
            <h4 class="display-message" *ngIf="isError && isProcessingCreateReport && isDesktopAndOffline">{{'inspectionReport.MsgPressRefresh2' | translate}}</h4>
          </ng-container>

          <ng-container *ngIf="!isSafari(browserName) && isDesktopAndOffline">
            <div>Report view</div>
          </ng-container>

          <!-- complete safari-->
          <ng-container *ngIf="isSafari(browserName)">
            <object *ngIf="pdfUrl" [data]="pdfUrl" type="application/pdf" scrolling="auto">
              <h3 *ngIf="!isError && isDownload">{{'inspectionReport.LoadPDF' | translate}}</h3>
              <h3 *ngIf="isError">{{'inspectionReport.PageNotFound' | translate}}</h3>
            </object>
            <h4 class="display-message" *ngIf="isError&&!isProcessingCreateReport">{{'inspectionReport.UnDisplayPDFRpt' | translate}}</h4>
            <h4 class="display-message" *ngIf="isError&&isProcessingCreateReport">{{'inspectionReport.MsgPressRefresh' | translate}}</h4>
          </ng-container>
        </div>

        <!-- pdf iPad -->
        <div *ngIf="isDeviceNameIpad(deviceName)" class="report-preview-ipad">
          <!--no plugin-->
          <ng-container *ngIf="!isPlugin">
            <h3>{{'inspectionReport.MsgInstallPDFViewer' | translate}}</h3>
          </ng-container>

          <ng-container *ngIf="!isSafari(browserName) && !isDesktopAndOffline">
            <iframe *ngIf="pdfUrl" [src]="pdfUrl" type="application/pdf">
              <h3 *ngIf="!isError && isDownload">{{'inspectionReport.LoadPDF' | translate}}</h3>
              <h3 *ngIf="isError">{{'inspectionReport.PageNotFound' | translate}}</h3>
            </iframe>
          </ng-container>

          <ng-container *ngIf="!isSafari(browserName) && isDesktopAndOffline">
            <div>Report view</div>
          </ng-container>

          <!-- complete safari-->
          <ng-container *ngIf="isSafari(browserName)">
            <object *ngIf="pdfUrl" [data]="pdfUrl" type="application/pdf" scrolling="auto">
              <h3 *ngIf="!isError && isDownload">{{'inspectionReport.LoadPDF' | translate}}</h3>
              <h3 *ngIf="isError">{{'inspectionReport.PageNotFound' | translate}}</h3>
            </object>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
